module.exports = __webpack_public_path__ + "static/media/PetPackage.17cf875c.md";